<template>
	<div class="shape"></div>
</template>

<script>
let cache = new Map()
export default {
	props: {
		src: { type: String, required: true }
	},
	watch: {
		src () {
			this.getSrc()
		}
	},
	methods: {
		async getSrc () {
			if (!cache.has(this.src)) {
				try {
					cache.set(this.src, fetch(this.src).then(r => r.text()))
				} catch (e) {
					cache.delete(this.src)
				}
			}
			if (cache.has(this.src)) {
				this.$el.innerHTML = await cache.get(this.src)
			}
		}
	},
	mounted() {
		this.getSrc()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/shapes/Shape.vue